import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';

export const changeAutoConfirmAction = createAction(ACTIONS.CHANGE_AUTO_CONFIRM)();

export const applyAutoConfirmAction = createAction(ACTIONS.APPLY_AUTO_CONFIRM)();
